import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../../axiosClient.js';
import Alert from '../common/Alert.jsx';
import PageLoading from '../common/PageLoading.jsx';
import QuotaBreakdownHeader from '../QuotaBreakdownHeader.jsx';
import CommGrossQuotaBreakdownRow from './CommGrossQuotaBreakdownRow.jsx';
const REFRESH_INTERVAL_MS = 300000;

function CommGrossQuotaBreakdownTable({ selectedRep, selectedYear }) {
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const fetchRows = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        `/api/commgross/quota-breakdown/${encodeURIComponent(selectedRep)}/${selectedYear}`
      );
      setRows(data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  }, [selectedRep, selectedYear]);
  React.useEffect(() => {
    setLoading(true);
    setError(null);
    setRows([]);
  }, [selectedRep, selectedYear]);
  useInterval(fetchRows, REFRESH_INTERVAL_MS, loading && !error);
  return (
    <Box>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Quota Breakdown
      </Typography>
      <Alert message={error} setMessage={setError} level="error" />
      {loading ? (
        <PageLoading />
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <QuotaBreakdownHeader />
            <TableBody>
              {rows.length ? (
                rows.map((quota) => (
                  <CommGrossQuotaBreakdownRow key={quota.CATEGORY} quota={quota} />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="20" sx={{ textAlign: 'center', p: 2 }}>
                    No quota data set for {selectedRep}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
export default React.memo(CommGrossQuotaBreakdownTable);
